import useFetch from './useFetch';
import {useRouter} from 'vue-router';

export default function usePagination(filter) {
  const router = useRouter();

  const { data: page, mutate} = useFetch(filter.key + '?' + filter.toQueryString(), filter.paginatedFetcher)

  const search = async () => {
    filter.page = 1;
    mutate();
    await router.replace({query: filter.toQuery()});
  }

  const changePage = async page => {
    filter.page = page;
    mutate();
    await router.replace({query: filter.toQuery()});
  }

  return {
    page,
    search,
    fetch: search,
    changePage
  }
}
